export default "__VITE_ASSET__CxipEW_S__"